export enum LicenseStatusEnum {
    Active = 'Active',
    Blocked = 'Blocked',
}
export enum LicenseStatus {
    Active = 1,
    Blocked,
}

export const licenseStatusEnumTranslationsPl = {
    Active: 'Aktywna',
    Blocked: 'Zablokowana',
};

export const licenseStatusEnumTranslationsEn = {
    Active: 'Active',
    Blocked: 'Blocked',
};

export const mapLicenseStatusToApiModel = (internalModel?: LicenseStatusEnum): LicenseStatus | undefined => {
    switch (internalModel) {
        case LicenseStatusEnum.Active:
            return LicenseStatus.Active;
        case LicenseStatusEnum.Blocked:
            return LicenseStatus.Blocked;
    }
};
